import { Button, Input } from "components"
import { useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const Graphic = ({
 isTable,
 setShowGraphChart,
 setShowTableChart,
 handleCheckboxChange,
 setCheckboxValues,
 checkboxValues,
 date,
 setDate,
 handleFetchCounterValues,
}: {
 isTable: boolean
 setShowGraphChart: (_value: boolean) => void
 setShowTableChart: (_value: boolean) => void
 handleCheckboxChange: any
 setCheckboxValues: (_value: any) => void
 checkboxValues: any
 date: any
 setDate: (_value: any) => void
 handleFetchCounterValues: () => void
}) => {
 // language translator
 const { t } = useTranslation("translation")
 const handleInputChange = (value: string, name: string) => {
  setDate((prevDate: any) => ({
   ...prevDate,
   [name]: value,
  }))
 }
 const handleExecute = () => {
  setShowTableChart(false)
  setShowGraphChart(false)
  if (isTable) {
   setShowTableChart(true)
  } else {
   setShowGraphChart(true)
  }
  if (date.begin && date.end) {
   handleFetchCounterValues()
  }
 }

 useEffect(() => {
  localStorage.setItem("checkboxValues", JSON.stringify(checkboxValues))
  const storedCheckboxValues = localStorage.getItem("checkboxValues")
  if (storedCheckboxValues) {
   setCheckboxValues(JSON.parse(storedCheckboxValues))
  }
 }, [])

 return (
  <AnimatePresence>
   <motion.div
    initial={{ opacity: 0, height: 0, y: -100 }}
    animate={{ opacity: 1, height: "auto", y: 0 }}
    exit={{ opacity: 0, height: 0, y: -100 }}
    transition={{ duration: 0.5, ease: "easeInOut" }}
   >
    <Box bg="highlight" color="text-black" className="mt-6 px-3 py-3 rounded ">
     <div className="flex justify-between">
      <div className="w-[32%]">
       <Input
        className="outline-none bg-gray py-3 rounded px-3 text-black"
        label={t("beginning")}
        type="date"
        id="begin"
        name="begin"
        value={date?.begin}
        onChange={handleInputChange}
       />
      </div>
      <div className="w-[32%]">
       <Input
        className="outline-none bg-gray py-3 rounded px-3 text-black"
        label={t("end")}
        type="date"
        id="end"
        name="end"
        value={date?.end}
        onChange={handleInputChange}
       />
      </div>
      <div className="w-[32%]">
       <Input
        className="outline-none bg-gray py-3 rounded px-3"
        label="Interval[min]:"
        type="number"
        id="interval"
        placeholder="0"
        min={0}
       />
      </div>
     </div>
     <div className="lg:flex-row flex-col flex my-2">
      <div className=" w-full lg:w-[35%]">
       <h1 className="font-md ">{t("allDetectors")}:</h1>
       <div className="py-3 flex">
        <div className="custom-checkbox">
         <input
          checked={checkboxValues["counter"] || false}
          onChange={() => handleCheckboxChange("counter")}
          type="checkbox"
          id="counter"
         />
         <label className="font-semi font-sm Jakarta-font" htmlFor="counter">
          {t("counterValues")}
         </label>
        </div>
        <div className="custom-checkbox ml-2">
         <input
          checked={checkboxValues["occupancy"] || false}
          onChange={() => handleCheckboxChange("occupancy")}
          type="checkbox"
          id="occupancy"
         />
         <label className="font-semi font-sm Jakarta-font" htmlFor="occupancy">
          {t("occupancyValues")}
         </label>
        </div>
       </div>
      </div>
      <div className="w-full lg:w-[35%]">
       <h1 className="font-md">{t("detectorsDisplayed")}:</h1>
       <div className="custom-checkbox py-3">
        <input type="checkbox" id="all" />
        <label className="font-semi font-sm Jakarta-font" htmlFor="all">
         {t("all")}
        </label>
       </div>
      </div>
     </div>
     <div className="w-full lg:w-[10%]">
      <Button onClick={handleExecute} size={"lg"}>
       {t("execute")}
      </Button>
     </div>
    </Box>
   </motion.div>
  </AnimatePresence>
 )
}
